import { render, staticRenderFns } from "./memo.vue?vue&type=template&id=43882032&scoped=true"
import script from "./memo.vue?vue&type=script&lang=js"
export * from "./memo.vue?vue&type=script&lang=js"
import style0 from "./memo.vue?vue&type=style&index=0&id=43882032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43882032",
  null
  
)

export default component.exports